/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Bucket_XlInputs */

const en_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Large Bucket`)
};

const es_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cubo extra grande`)
};

const de_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra großer Eimer`)
};

const zh_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加大桶`)
};

const ar_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلة كبيرة جداً`)
};

const fr_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seau très grand`)
};

const vi_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xô rất lớn`)
};

const sw_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ndoo Kubwa Zaidi`)
};

const th_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถังใหญ่พิเศษ`)
};

const bs_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra velika kanta`)
};

const ja_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XLバケット`)
};

const ko_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`엑스트라 라지 버킷`)
};

const pt_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balde extra grande`)
};

const it_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestino extra large`)
};

const sv_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra stor hink`)
};

const nl_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra grote emmer`)
};

const da_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra stor kurv`)
};

const nb_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra stor kurv`)
};

const fi_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erittäin suuri ämpäri`)
};

const pl_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bardzo duży koszyk`)
};

const ru_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очень большая корзина`)
};

const tr_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra Büyük Kova`)
};

const hi_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अतिरिक्त बड़ी बाल्टी`)
};

const id_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ember Ekstra Besar`)
};

const ms_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baldi Ekstra Besar`)
};

const cs_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra velký košík`)
};

const el_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πολύ μεγάλος κουβάς`)
};

const he_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דלי גדול במיוחד`)
};

const af_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra groot emmer`)
};

const hu_prices_label_bucket_xl = /** @type {(inputs: Prices_Label_Bucket_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra nagy vödör`)
};

/**
* | output |
* | --- |
* | "Extra Large Bucket" |
*
* @param {Prices_Label_Bucket_XlInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_bucket_xl = /** @type {((inputs?: Prices_Label_Bucket_XlInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Bucket_XlInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_bucket_xl(inputs)
	if (locale === "de") return de_prices_label_bucket_xl(inputs)
	if (locale === "zh") return zh_prices_label_bucket_xl(inputs)
	if (locale === "ar") return ar_prices_label_bucket_xl(inputs)
	if (locale === "fr") return fr_prices_label_bucket_xl(inputs)
	if (locale === "vi") return vi_prices_label_bucket_xl(inputs)
	if (locale === "sw") return sw_prices_label_bucket_xl(inputs)
	if (locale === "th") return th_prices_label_bucket_xl(inputs)
	if (locale === "bs") return bs_prices_label_bucket_xl(inputs)
	if (locale === "ja") return ja_prices_label_bucket_xl(inputs)
	if (locale === "ko") return ko_prices_label_bucket_xl(inputs)
	if (locale === "pt") return pt_prices_label_bucket_xl(inputs)
	if (locale === "it") return it_prices_label_bucket_xl(inputs)
	if (locale === "sv") return sv_prices_label_bucket_xl(inputs)
	if (locale === "nl") return nl_prices_label_bucket_xl(inputs)
	if (locale === "da") return da_prices_label_bucket_xl(inputs)
	if (locale === "nb") return nb_prices_label_bucket_xl(inputs)
	if (locale === "fi") return fi_prices_label_bucket_xl(inputs)
	if (locale === "pl") return pl_prices_label_bucket_xl(inputs)
	if (locale === "ru") return ru_prices_label_bucket_xl(inputs)
	if (locale === "tr") return tr_prices_label_bucket_xl(inputs)
	if (locale === "hi") return hi_prices_label_bucket_xl(inputs)
	if (locale === "id") return id_prices_label_bucket_xl(inputs)
	if (locale === "ms") return ms_prices_label_bucket_xl(inputs)
	if (locale === "cs") return cs_prices_label_bucket_xl(inputs)
	if (locale === "el") return el_prices_label_bucket_xl(inputs)
	if (locale === "he") return he_prices_label_bucket_xl(inputs)
	if (locale === "af") return af_prices_label_bucket_xl(inputs)
	if (locale === "hu") return hu_prices_label_bucket_xl(inputs)
	return en_prices_label_bucket_xl(inputs)
});